import React from "react";
import FormArea from "./form";

const ContactMain = ({ contact }) => {
    if (!contact) return null;

    return (
        <section className="contact section-padding">
            <div className="container">
                <div className="row">

                    {/* LEFT */}
                    <div className="col-lg-5 lg-mb-25">
                        <div className="contact__left">

                            <div className="contact__header">
                                <span className="contact__subtitle">
                                    Contact Us
                                </span>
                                <h2 className="contact__title">
                                    Get In Touch
                                </h2>
                                <p className="contact__desc">
                                    We’re here to assist you with project inquiries,
                                    partnerships, and operational support.
                                </p>
                            </div>

                            <div className="contact__list">

                                {/* PHONE */}
                                {contact.phone && (
                                    <ContactItem
                                        icon="flaticon-phone"
                                        label="Phone"
                                        value={formatPhone(contact.phone)}
                                        link={`tel:+${contact.phone}`}
                                    />
                                )}

                                {/* EMAIL */}
                                {contact.email && (
                                    <ContactItem
                                        icon="flaticon-email-3"
                                        label="Email Address"
                                        value={contact.email}
                                        link={`mailto:${contact.email}`}
                                    />
                                )}

                                {/* OFFICES */}
                                {contact.office?.map((office, index) => (
                                    <ContactItem
                                        key={index}
                                        icon="flaticon-location-1"
                                        label={office.label}
                                        value={office.address}
                                        link={office.gmaps}
                                        external
                                    />
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* RIGHT */}
                    <div className="col-lg-7">
                        <div className="contact__form">
                            <h4 className="contact__form-title">
                                Send Message
                            </h4>
                            <FormArea />
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

/* ===== REUSABLE CONTACT ITEM ===== */
const ContactItem = ({
                         icon,
                         label,
                         value,
                         link,
                         external = false
                     }) => (
    <div className="contact__item">
        <div className="contact__item-icon">
            <i className={icon} />
        </div>

        <div className="contact__item-content">
            <span>{label}</span>
            <h6>
                <a
                    href={link}
                    target={external ? "_blank" : undefined}
                    rel={external ? "noopener noreferrer" : undefined}
                >
                    {value}
                </a>
            </h6>
        </div>
    </div>
);

const formatPhone = (phone) => {
    if (phone.startsWith("62")) {
        return "0" + phone.slice(2);
    }
    return phone;
};

export default ContactMain;
